'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.save = save;
exports.load = load;
exports.deleteUserData = deleteUserData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'saveUserData/LOAD';
var LOAD_SUCCESS = 'saveUserData/LOAD_SUCCESS';
var LOAD_FAIL = 'saveUserData/LOAD_FAIL';
var SAVE = 'saveUserData/SAVE';
var SAVE_SUCCESS = 'saveUserData/SAVE_SUCCESS';
var SAVE_FAIL = 'saveUserData/SAVE_FAIL';
var DELETE = 'saveUserData/DELETE';
var DELETE_SUCCESS = 'saveUserData/DELETE_SUCCESS';
var DELETE_FAIL = 'saveUserData/DELETE_FAIL';

var initialState = {
  loaded: false,
  loaded_data: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SAVE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SAVE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case SAVE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded_data: true,
        load_data: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case DELETE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case DELETE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        load_data: action.result
      });
    case DELETE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state;
  }
}

function save(data) {
  var infoBlock = data.info;
  var info_data = [];
  for (var key in infoBlock) {
    if (infoBlock.hasOwnProperty(key)) {
      info_data = info_data.concat(infoBlock[key]);
    }
  }
  data.info = info_data;
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.post('/save-user-data/', { data: data });
    }
  };
}

function load(div_content_id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/load-user-data/?template_type=' + div_content_id);
    }
  };
}

function deleteUserData(data) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: function promise(client) {
      return client.post('/delete-user-data/', { data: data });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/saveUserData.js
// module id = 81
// module chunks = 0